<template>
  <el-upload class="cus_image_upload" :action="fileUploadUrl" :show-file-list="false" :before-upload="beforeupload" :http-request="customupload" :on-success="onsuccess">
    <template v-if="imageUrl">
      <img :src="imageUrl" />
    </template>
    <template v-else>
      <i class="el-icon-plus"></i>
    </template>
  </el-upload>
</template>

<script>
export default {
  props: {
    uploadFiles: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      fileUploadList: null,
      fileUploadUrl: process.env.VUE_APP_BASE_API + "/api/upload/uploadfile",
    };
  },
  watch: {
    uploadFiles: {
      handler(data) {
        this.fileUploadList = [];
        if (data != null && data.length > 0) {
          data.forEach((element) => {
            this.fileUploadList.push(element);
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    imageUrl() {
      let fileUploadList = this.fileUploadList;
      if (fileUploadList != null && fileUploadList.length > 0) {
        return fileUploadList[0].url;
      }
      return null;
    },
  },
  methods: {
    beforeupload(file) {
      let isIMG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isIMG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
      }

      let isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 3MB!");
      }
      return isIMG && isLt3M;
    },
    customupload(data) {
      let formData = new FormData();
      formData.append("file", data.file);

      this.$store
        .dispatch("upload/UploadFile", formData)
        .then((result) => {
          data.onSuccess(result);
        })
        .catch(() => {});
    },
    onsuccess(response, file, fileList) {
      this.fileUploadList = [];
      let { fileName, fileUrl } = response;
      this.fileUploadList.push({ name: fileName, url: fileUrl });
      this.$emit("onsuccess", { uploadFiles: this.fileUploadList });
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./upload.scss");
</style>
